import React, { FC, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ResendInviteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  inviteEmail: string;
}

export const ResendInviteDialog: FC<ResendInviteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  inviteEmail,
}) => {
  const { t } = useTranslation();
  const [isResending, setIsResending] = useState(false);

  const handleConfirm = async () => {
    setIsResending(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Error handling is done in the parent component
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent>
        <Typography variant="MHHeading" mb={1}>
          Resend Invite
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Are you sure you want to resend the invite to <strong>{inviteEmail}</strong>?
        </Typography>
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="brandContained"
            color="brandGrey"
            onClick={onClose}
            disabled={isResending}
            sx={{ mr: 1 }}
            data-cy="cancel-resend-invite-button">
            {t('actions.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="brandContained"
            color="brandBlack"
            startIcon={isResending ? <CircularProgress size="1em" /> : undefined}
            disabled={isResending}
            data-cy="confirm-resend-invite-button">
            Resend
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
